<template>
    <svg v-if="isOpen" @click="toggle"
         :class="'text-' + link_color"
         class="w-5 h-5 mt-0.5 text-opacity-100"
         xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24"
         stroke-width="2" stroke="currentColor" fill="none"
         stroke-linecap="round"
         stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <circle cx="12" cy="12" r="9"></circle>
        <line x1="9" y1="12" x2="15" y2="12"></line>
    </svg>

    <svg v-if="!isOpen" @click="toggle"
         :class="'group-hover:text-' + link_color"
         class="w-5 h-5 opacity-60 mt-0.5 group-hover:opacity-100"
         xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2"
         stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <circle cx="12" cy="12" r="9"></circle>
        <line x1="9" y1="12" x2="15" y2="12"></line>
        <line x1="12" y1="9" x2="12" y2="15"></line>
    </svg>

    <div class="flex-1 space-y-4">
        <h5 @click="toggle"
            :class="isOpen ? 'text-' + link_color + ' ' + 'group-hover:text-' + link_color : 'group-hover:text-' + link_color"
            class="text-base font-semibold text-opacity-100 hover:underline">
            {{ question }}</h5>
        <div v-if="isOpen">
            <p class="text-sm text-gray-600">{{ answer }}</p>
        </div>
    </div>
</template>
<script>
export default {
    props: ['question', 'answer', 'open', 'link_color'],
    data() {
        return {
            isOpen: this.open || false
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    }
}
</script>
